const platforms = [
	{
		path: '/community/wikigamer/platforms',
		name: 'community-wikigamer-platforms-root',
		component: () => import('@/views/community/wikigamer/platforms/platforms/list.vue'),
		meta: { layout: 'content', module: 'MGC,wikigamer' },
	},
	{
		path: '/community/wikigamer/platforms/platforms/list',
		name: 'community-wikigamer-platforms-list',
		component: () => import('@/views/community/wikigamer/platforms/platforms/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/community/wikigamer/platforms/platforms/new',
		name: 'community-wikigamer-platforms-create',
		component: () => import('@/views/community/wikigamer/platforms/platforms/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/community/wikigamer/platforms/platforms/:slug/edit',
		name: 'community-wikigamer-platforms-edit',
		component: () => import('@/views/community/wikigamer/platforms/platforms/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},

	{
		path: '/community/wikigamer/platforms/types/list',
		name: 'community-wikigamer-platforms-types-list',
		component: () => import('@/views/community/wikigamer/platforms/types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/community/wikigamer/platforms/family/list',
		name: 'community-wikigamer-platforms-family-list',
		component: () => import('@/views/community/wikigamer/platforms/family/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
	{
		path: '/community/wikigamer/platforms/generations/list',
		name: 'community-wikigamer-platforms-generations-list',
		component: () => import('@/views/community/wikigamer/platforms/generations/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
]

export default platforms
